export const stringHelper = {
  methods: {
    empty(str) {
      return (!str || 0 === str.length);
    },
  }
};
